// SortableAccordian.js
import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import Accordian from "./accordian";

const SortableAccordian = ({ id, showDragHandle = true, ...props }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div ref={setNodeRef} style={style}>
      <Accordian
        {...props}
        showDragHandle={showDragHandle}
        dragHandleProps={
          showDragHandle ? { ...listeners, ...attributes } : undefined
        }
      />
    </div>
  );
};

export default SortableAccordian;
